import { DetailedWorkspaceDto, ReviewFormDataType, TaxReturnItemRequest, UserClaims, ViewFormResponseFormFields } from '../model';

export const FORM_CACHE_STORE_NAME = 'FormCache';
export const DB_FORM_CACHE_NAME = 'FormCacheDB';

/**
 * Cache-key schema version, appended to every record id. Bumping it makes every
 * existing record unreachable, forcing a server round trip for all form views —
 * the manual invalidation lever for releases where cached form content is known
 * to be wrong or the request contract changed in a way the key can't express.
 */
export const FORM_CACHE_KEY_VERSION = '1';

export interface IFormCacheRecord {
    id: string;
    returnKey: string;
    tocItemId: string;
    formData: string;
    versionId?: string;
    columnId?: number;
    columnIndex?: number;
    formFields?: ViewFormResponseFormFields;
    dataType?: ReviewFormDataType;
    detailedWorkspace?: DetailedWorkspaceDto;
}

export const adaptReportToIFormCacheRecord = (
    returnKey: string,
    data: string,
    enterpriseId?: string,
    dataRequest?: TaxReturnItemRequest,
    versionId?: string,
    formFields?: ViewFormResponseFormFields,
    dataType?: ReviewFormDataType,
    detailedWorkspace?: DetailedWorkspaceDto
): IFormCacheRecord | null => {
    if (dataRequest && dataRequest?.taxReturnTOCItems && dataRequest.taxReturnTOCItems[0]?.id) {
        const formCacheRecord: IFormCacheRecord = {
            id: getRecordId(
                dataRequest.taxReturnTOCItems[0].id,
                returnKey,
                enterpriseId,
                versionId,
                dataRequest.columnId?.toString(),
                dataRequest.columnIndex?.toString()
            ),
            returnKey: returnKey.toString(),
            columnId: dataRequest.columnId,
            columnIndex: dataRequest.columnIndex,
            tocItemId: dataRequest.taxReturnTOCItems[0].id,
            versionId: versionId || '',
            formData: data,
            formFields,
            dataType,
            detailedWorkspace,
        };
        return formCacheRecord;
    }
    return null;
};

export const getFormCacheStoreName = (userClaims?: UserClaims): string | null => {
    if (!userClaims) {
        return null;
    }

    return `${FORM_CACHE_STORE_NAME}_${userClaims.environmentName}_${userClaims.userId}`;
};

export const getRecordId = (
    taxReturnTOCItemId: string,
    returnKey: string,
    enterpriseId?: string,
    versionId?: string,
    columnId?: string,
    columnIndex?: string
): string => {
    let recordId = `${taxReturnTOCItemId}-${returnKey}`;
    if (enterpriseId) {
        recordId += `-${enterpriseId}`;
    }
    if (versionId) {
        recordId += `-${versionId}`;
    }
    if (columnId) {
        recordId += `-${columnId}`;
    }
    if (columnIndex) {
        recordId += `-${columnIndex}`;
    }
    recordId += `-v${FORM_CACHE_KEY_VERSION}`;
    return recordId;
};

export const formIndexedDBSchema = (db: IDBDatabase, storeName: string) => {
    const objectStore = db.createObjectStore(storeName, { keyPath: 'id' });
    objectStore.createIndex('returnKey', 'returnKey', { unique: false });
};
